import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from '../../v2/Button'
import { CategorySearchLinksProps } from './types'
import { useIsMobile } from 'spa/member/hooks/v2/useScreenSize'

const breakLongCategoryName = (name: string) => {
  return <span>{name.slice(0, 20)}<br />{name.slice(20)}</span>
}

export const StyledCategorySearchLinks: React.FC<CategorySearchLinksProps> = ({ categories }) => {
  const isMobile = useIsMobile()

  return (
    <div>
      <ul className="flex flex-wrap gap-2XS tablet:gap-XS">
        {
          categories.map((category) => (
            <li key={category.id}>
              <Link to={`/job_offers/o/${category.id}`}>
                <Button kind="outline" buttonType={isMobile ? 'XS' : 'SMALL'} link>
                  {isMobile && (category.name || '').length > 20 ? breakLongCategoryName(category.name) : category.name}
                </Button>
              </Link>
            </li>
          ))
        }
      </ul>
    </div>
  )
}
